const programme = {
   
    state: {
        isBuyNow: false,
        programmeBuyNow:{}
    },
    mutations:{
        setIsBuyNow(state, isBuyNow){
          state.isBuyNow = isBuyNow
        },
        setProgrammeBuyNow(state, programmeBuyNow){
          state.programmeBuyNow = programmeBuyNow
        },
    },
    actions:{
        setIsBuyNow(context,isBuyNow){
            context.commit('setIsBuyNow', isBuyNow)
        },
        setProgrammeBuyNow(context,programmeBuyNow){
            context.commit('setProgrammeBuyNow', programmeBuyNow)
        },
    }

}

export default programme